// This feature is currently not active in the player (since the respective button is hidden)
// It needs proper testing before being activated in production!
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { Component } from "react";
import { injectIntl } from "react-intl";
import throttle from "lodash/throttle";
import SocialViewActionCreators from "../actions/SocialViewActionCreators";
import Log from "../utils/Log";
import { getCurrentTopic } from "../utils/SocialTopicsUtils";
var ActivityDeletor = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ActivityDeletor, Component);
    var _super = _createSuper(ActivityDeletor);
    function ActivityDeletor(props) {
        _classCallCheck(this, ActivityDeletor);
        var _this;
        _this = _super.call(this, props);
        _this.renderFormErrors = function() {
            var errors = _this.state.errors;
            var intl = _this.props.intl;
            return /*#__PURE__*/ React.createElement("ul", {
                className: "social-activity-editor__errors"
            }, errors && errors.length > 0 ? Object.keys(errors).map(function(key) {
                return /*#__PURE__*/ React.createElement("li", {
                    key: key,
                    className: "social-activity-deletor__error"
                }, intl.formatMessage({
                    id: "social.activities.validations." + key + "." + errors[key][0],
                    defaultMessage: errors[key][0]
                }) || "".concat(key, ": ").concat(errors[key][0]));
            }) : null);
        };
        _this._handleAction = function(eventName) {
            var _this_props = _this.props, intl = _this_props.intl, sendAlert = _this_props.sendAlert;
            switch(eventName){
                case "delete":
                    if (!_this.state.isDeleting) {
                        throttle(_this._doDelete, 200)();
                    } else {
                        sendAlert(intl.formatMessage({
                            id: "social.activities.action_not_possible_while_deleting",
                            defaultMessage: "Action not possible while deleting"
                        }), "warning");
                    }
                    break;
                case "cancel":
                    if (!_this.state.isDeleting) {
                        _this._doCancel();
                    } else {
                        sendAlert(intl.formatMessage({
                            id: "social.activities.action_not_possible_while_deleting",
                            defaultMessage: "Action not possible while deleting"
                        }), "warning");
                    }
                    break;
                default:
                    Log.log("What to do: " + eventName);
                    break;
            }
        };
        _this._doDelete = function() {
            var activity = _this.props.activity;
            _this.setState({
                isSaving: true
            });
            // TO DO: move this to actions that get dispatched in the container
            // and change the async handling of the promise accordingly
            SocialViewActionCreators.deleteActivity(activity, getCurrentTopic()).then(_this._onActivityDeleted, _this._onInvalidDelete);
        };
        _this._onActivityDeleted = function() {
            var _this_props = _this.props, onDeleted = _this_props.onDeleted, activity = _this_props.activity, topic = _this_props.topic;
            if (onDeleted && typeof onDeleted === "function") {
                onDeleted(activity, topic);
            }
        };
        _this._onInvalidDelete = function(activity) {
            var _this_props = _this.props, intl = _this_props.intl, sendAlert = _this_props.sendAlert;
            sendAlert(intl.formatMessage({
                id: "social.activities.delete_answer_failed",
                defaultMessage: "Deleting answer failed"
            }), "danger");
            _this.setState({
                errors: activity.errorThrown ? activity.errorThrown.errors : [],
                isSaving: false
            });
        };
        _this.state = {
            isDeleting: false,
            isSaving: false,
            errors: []
        };
        return _this;
    }
    var _proto = ActivityDeletor.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.action.addListener("action", this._handleAction);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.action.removeListener("action", this._handleAction);
    };
    _proto.render = function render() {
        var _this_props = this.props, intl = _this_props.intl, activity = _this_props.activity, topic = _this_props.topic;
        var errors = this.state.errors;
        return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
            className: "social-app-options"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "social-app-options_title"
        }, topic.title)), /*#__PURE__*/ React.createElement("div", {
            className: "social-activity-deletor"
        }, errors.length ? this.renderFormErrors() : null, /*#__PURE__*/ React.createElement("div", {
            className: "social-activity-deletor__confirm-message"
        }, intl.formatMessage({
            id: "social.activities.confirm_delete",
            defaultMessage: "Are you sure you want to delete this message?"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "social-activity-deletor__activity-body",
            dangerouslySetInnerHTML: {
                __html: activity.body
            }
        })));
    };
    return ActivityDeletor;
}(Component);
export default injectIntl(ActivityDeletor);
